// একটা সেলের বাকি টাকা আসলে কার কাছে আছে — কাস্টমারের কাছে, নাকি কুরিয়ারের কাছে?
//
// Direct Sale-এ বাকি টাকা মানে কাস্টমার টাকাটা বাকি রেখেছে — ওটা আদায় করতে হবে।
// কিন্তু Courier Delivery সেলে কাস্টমার কিছুই বাকি রাখেনি: পুরো টাকাটা COD হিসেবে
// পার্সেলের সাথে কুরিয়ারের কাছে যাচ্ছে, ডেলিভারির পর Pathao সেটা পাঠাবে।
//
// টাকার অঙ্ক এক হলেও মালিক আলাদা, তাই দুটোকে এক তালিকায় মেশানো যাবে না — মেশালে
// "কে কত টাকা বাকি রেখেছে" ভুল দেখাবে এবং ভালো কাস্টমারকেও বাকিদার মনে হবে।
//
// চেনা হচ্ছে deliveryMethod দিয়ে, নতুন কোনো ফিল্ড দিয়ে নয় — তাই এই ভাগটা চালু হওয়ার
// আগে করা পুরনো কুরিয়ার সেলগুলোও কোনো ডেটা migration ছাড়াই ঠিক জায়গায় পড়বে।
export const isCourierCod = (sale) =>
  sale?.deliveryMethod === 'courier' && Number(sale?.dueAmount || 0) > 0;

// কাস্টমারের কাছে সত্যিই বাকি থাকা টাকা।
export const isCustomerDue = (sale) =>
  Number(sale?.dueAmount || 0) > 0 && !isCourierCod(sale);

// কুরিয়ারকে এই পার্সেল থেকে কত টাকা তুলতে বলতে হবে।
//
// ⚠️ এটা সবসময় বাকি টাকা (dueAmount), মোট বিল নয়। কাস্টমার যদি আগেই পুরো টাকা
// bKash-এ দিয়ে দেয়, তাহলে dueAmount = 0 এবং কুরিয়ারকে ০ টাকাই তুলতে বলতে হবে —
// এখানে ভুল করে totalBill পাঠালে কাস্টমারের কাছ থেকে দ্বিতীয়বার টাকা নেওয়া হয়ে যাবে।
//
// totalBill-এ ফেরত যাওয়া হয় শুধু তখনই যখন dueAmount ফিল্ডটা ডকুমেন্টে নেই-ই
// (খুব পুরনো সেল, যেগুলো এই ফিল্ড সেভ হওয়া শুরুর আগের) — ০ থাকা আর না থাকা এক নয়।
export const codAmountFor = (sale) =>
  sale?.dueAmount == null ? (Number(sale?.totalBill) || 0) : (Number(sale.dueAmount) || 0);

// ---- Pathao-র COD Fee ----
// Pathao COD টাকার ১% "COD Fee" কেটে নেয় (তাদের রেট পেজে: "1% Cash On Delivery Fee May Apply";
// একটা আসল অর্ডারে ৳7,650 COD-তে ৳76.50 কাটতে দেখা গেছে)। এটা ডেলিভারি ফি-র বাইরে আলাদা একটা কাটা,
// আর কাস্টমারকে চার্জ করা হয় না -- Pathao দোকানকে COD-র টাকা পাঠানোর সময় নিজেরাই কেটে রাখে,
// তাই এটা সবসময়ই দোকানের খরচ (Accounts/Reports/Home-এর প্রফিট থেকে বাদ যায়)।
export const COD_FEE_RATE = 0.01;

// টাকার অঙ্ক দুই দশমিক পর্যন্ত রাখা হয়, কারণ Pathao নিজেও ৳76.50 / ৳186.50 এভাবে দেখায়।
export const codFeeOf = (codAmount) => Math.round((Number(codAmount) || 0) * COD_FEE_RATE * 100) / 100;

// ফি দেখানোর জন্য: পূর্ণ সংখ্যা হলে দশমিক ছাড়া (৳110), নাহলে দুই দশমিকে (৳76.50)।
export const formatFee = (n) => {
  const v = Number(n) || 0;
  return new Intl.NumberFormat('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v);
};

// এই সেলের জন্য Pathao কত COD Fee কাটবে (কাটবে না হলে ০)।
//  - Steadfast-এ বুক হলে বা Steadfast বেছে রাখা থাকলে ০: ওদের COD নিয়ম আমাদের জানা নেই, আন্দাজে ধরা হচ্ছে না।
//  - রিটার্ন/ক্যানসেল হলে ০: পার্সেল ডেলিভারি হয়নি, COD আদায়ও হয়নি, তাই COD Fee-ও লাগেনি।
//  - বুক করা থাকলে বুকিংয়ের সময় Pathao-কে যত COD পাঠানো হয়েছিল (courierBooking.codAmount) সেটাই ধরা হয়।
//    নাহলে পরে টাকা Receive করলে dueAmount ০ হয়ে যায় আর খরচটা হিসাব থেকে উধাও হয়ে যেত -- অথচ Pathao কেটেছেই।
//  - বুক করা না থাকলে এখনকার COD (dueAmount) দিয়ে আনুমানিক ধরা হয়, বুক হলে আসল সংখ্যায় বদলে যায়।
//  - পুরনো (এই ফিল্ড আসার আগের) বুকিংয়ে codAmount নেই, তখন এখনকার COD ধরা হয়।
export const codFeeFor = (sale) => {
  const booking = sale?.courierBooking;
  const provider = booking?.provider || sale?.preferredCourier;
  if (provider === 'steadfast') return 0;
  if (/return|cancel/i.test(booking?.status || '')) return 0;
  if (booking && booking.codAmount != null) return codFeeOf(booking.codAmount);
  return isCourierCod(sale) ? codFeeOf(codAmountFor(sale)) : 0;
};

// COD টাকাটা এখন কোন অবস্থায় আছে — কুরিয়ার বুক হয়েছে কিনা, হলে কী স্ট্যাটাস।
export const courierStatusText = (sale) => {
  const booking = sale?.courierBooking;
  if (!booking?.consignmentId) return 'Not booked yet';
  return booking.status || 'Booked';
};
